import { Component, OnDestroy, AfterViewInit, ViewChild, Input } from '@angular/core'
import { GridsterConfig, GridsterItem } from 'angular-gridster2';
import { Router } from '@angular/router'

import { appStateProvider } from '../../../insa-providers'
import { InsaService } from '../../../insa-services'
import { MainEntryDataModel } from '../../../insa-models';
//import { appConfig } from '../../../../insaweb.config'
//import { GridsterItemComponent } from 'angular-gridster2/dist/gridsterItem.component';
//import { setTimeout } from 'core-js/library/web/timers';

@Component({
    selector: 'menuEntry-widget',
    templateUrl: 'menuEntry.component.html'
})

export class MenuEntry implements OnDestroy, AfterViewInit {
    private randomId = Date.now().toString() + Math.ceil((Math.random() * 100000)).toString();
    private title = '';
    private menuEntryID = "menuEntryGridster" + this.randomId;
    private entryData: MainEntryDataModel[];
    private spaceWidth: number;
    private spaceHeight: number;
    @Input() private type: string;

    constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _router: Router) {

    }

    private gridsterBasicParams = {
        margin: 10,
        cellWidth: 30,
        cellHeight: 30
    }

    @ViewChild('gridster') gridster;
    private gridsterOptions: GridsterConfig = {
        gridType: 'fixed',
        compactType: 'none',
        initCallback: undefined,
        destroyCallback: undefined,
        itemChangeCallback: this.saveMainWindowLayout.bind(this),
        itemResizeCallback: undefined,
        itemInitCallback: undefined,
        itemRemovedCallback: undefined,
        margin: this.gridsterBasicParams.margin,
        outerMargin: true,
        mobileBreakpoint: 640,
        minCols: 1,
        maxCols: 100,
        minRows: 1,
        maxRows: 100,
        maxItemCols: 100,
        minItemCols: 1,
        maxItemRows: 100,
        minItemRows: 1,
        maxItemArea: 2500,
        minItemArea: 1,
        defaultItemCols: 1,
        defaultItemRows: 1,
        fixedColWidth: this.gridsterBasicParams.cellWidth,
        fixedRowHeight: this.gridsterBasicParams.cellHeight,
        keepFixedHeightInMobile: false,
        keepFixedWidthInMobile: false,
        scrollSensitivity: 10,
        scrollSpeed: 20,
        enableEmptyCellClick: false,
        enableEmptyCellContextMenu: false,
        enableEmptyCellDrop: false,
        enableEmptyCellDrag: false,
        emptyCellClickCallback: undefined,
        emptyCellContextMenuCallback: undefined,
        emptyCellDropCallback: undefined,
        emptyCellDragCallback: undefined,
        emptyCellDragMaxCols: 50,
        emptyCellDragMaxRows: 50,
        draggable: {
            delayStart: 0,
            enabled: true,
            ignoreContentClass: 'gridster-item-content',
            ignoreContent: false,
            dragHandleClass: '',
            stop: undefined
        },
        resizable: {
            delayStart: 0,
            enabled: false,
            stop: undefined,
            handles: {
                s: true,
                e: true,
                n: true,
                w: true,
                se: true,
                ne: true,
                sw: true,
                nw: true
            }
        },
        swap: true,
        pushItems: false,
        disablePushOnDrag: false,
        disablePushOnResize: false,
        pushDirections: { north: true, east: true, south: true, west: true },
        pushResizeItems: false,
        displayGrid: 'onDrag&Resize',
        disableWindowResize: false,
        disableWarnings: false,
        scrollToNewItems: false
    }
    private blaItem: GridsterItem = { cols: 3, rows: 3, y: 0, x: 0 };
    private gridsterItems = [];

    saveMainWindowLayout(gridsterItem, gridsterItemComponent) {
        //localStorage['mainWindowLayout'] = JSON.stringify(this.gridsterItems);
        return true;
    }

    calculateNumberOfColumnsAndRows() {
      if (this.gridster) {
        this.spaceWidth = $("#" + this.menuEntryID).width();
        this.spaceHeight = $("#" + this.menuEntryID).height();
        this.gridsterOptions.maxCols = Math.floor(this.spaceWidth / 25);
        this.gridsterOptions.maxRows = Math.floor(this.spaceHeight / 25);
        this.gridster.optionsChanged();
      }
    }
    setTilesDataSource() {
        this._insaService.getEntriesFromNavigatorSettings(this.type).subscribe(
            (navData: MainEntryDataModel[]) => { //holi
                this.entryData = navData;
                this.gridsterItems = this.entryData.map((entry, ix) => {
                    let grds: GridsterItem = {
                        cols: 3,
                        rows: 2,
                        x: (ix % 6) * 3,
                        y: Math.floor(ix / 6) * 3,
                    }
                    return grds
                })
                // console.log(this.entryData);
            }
        );
    }

    ngAfterViewInit() {
        this.title = this.type == 'favorites' ? 'Favorites' : 'Last Used';
        this.setTilesDataSource();
        setTimeout(() => this.calculateNumberOfColumnsAndRows(), 300);
    }

    ngOnDestroy() {

    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/menuEntry.component.ts